import '../../stylesheets/skeletons/statsSkeletons.css';
import { Fragment } from 'react';

const StatsSkeleton = () => {
    // varying pill widths mimic the descending-by-count pattern of real decsending order usage stats data render
    const pillWidths   = ['90%', '75%', '50%', '45%', '10%'];
    // slight variation on label widths — real labels are sector names of differing length
    const labelWidths  = ['100%', '90%', '95%', '85%', '90%'];

    return (
        <div className="stats-skeleton-content-container">
            <div className="stats-skeleton-main-column-one"></div>

            <div className="stats-skeleton-main-column-two">
                <div className="stats-skeleton-grid-label"></div>
                {pillWidths.map((pillWidth, i) => (
                    <Fragment key={i}>
                        <div className="stats-skeleton-row-label" style={{ width: labelWidths[i] }}></div>
                        <div className="stats-skeleton-row-bar"   style={{ width: pillWidth      }}></div>
                        <div className="stats-skeleton-row-value"></div>
                    </Fragment>
                ))}
            </div>

            <div className="stats-skeleton-main-column-three"></div>
        </div>
    );
};

export default StatsSkeleton;
